import { Button } from '$components'
import { useUpdateSizeCategoryForm } from './index'

export function UpdateSizeCategoryFormControls() {
  const { onCancel, isLoading } = useUpdateSizeCategoryForm()

  return (
    <div className="flex gap-4 mt-auto ml-auto">
      <Button
        type="button"
        variant="ghost"
        size="lg"
        onClick={onCancel}
      >
        Cancel
      </Button>

      <Button
        isLoading={isLoading}
        type="submit"
        size="lg"
      >
        Save Changes
      </Button>
    </div>
  )
}
